// import 'hammerjs';
import { APP_INITIALIZER, enableProdMode, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpConfigInterceptor } from './app/services/httpconfig.interceptor';
import { ErrorInterceptor } from './app/@shared/interceptor/error.interceptor';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ThemeModule } from './app/@theme/theme.module';
import { GenericTableAppModule } from './app/@generic-table-app/generic-table-app.module';
import { PagosModule } from './app/pages/@components/pagos/pagos.module';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { appReducers } from './app/@store/app.reducers';
import { EffectsModule } from '@ngrx/effects';
import { effectsArr } from './app/@store/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { ComplementoWebModule } from './app/pages/complemento-web/complemento-web.module';
import { IframeModalModule } from './app/pages/@components/iframe-modal-render/iframe-modal-render.module';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import moment from 'moment';
import 'moment/locale/es-mx';
import { VersionCheckerService } from './app/services/utilidades/version-checker.service';
import { GlobalErrorHandler } from './app/services/utilidades/error-handler';

if (environment.production) {
  enableProdMode();
}

//Service worker en caso de estar instalado
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      const sw = registration.active || registration.installing || registration.waiting;
      if (sw?.scriptURL.includes('ngsw-worker.js')) {
        registration.unregister();
      }
    });
  });
}

moment.locale('es-mx');

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppRoutingModule, ThemeModule.forRoot(), GenericTableAppModule, PagosModule, ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
      //NGRX
      StoreModule.forRoot(appReducers), EffectsModule.forRoot(effectsArr), StoreDevtoolsModule.instrument({
        maxAge: 25,
        logOnly: environment.production
      }),
      //FIREBASE
      // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
      AngularFireModule.initializeApp(environment.firebaseConfig), AngularFireMessagingModule, PagosModule, ComplementoWebModule, IframeModalModule),
    CookieService,
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
    // MOVER AQUÍ: Las funciones de Firebase modernas
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideStorage(() => getStorage()),
    provideMessaging(() => getMessaging()),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideAppInitializer(() => {
      const versionCheckerService = inject(VersionCheckerService);
      return versionCheckerService.initVersionCheck();
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
})
  .catch(err => console.error(err));
